// extracted by mini-css-extract-plugin
module.exports = {"socialMediaLinks":"socialMediaLinks_socialMediaLinks__hgHSo","tekst":"socialMediaLinks_tekst__3LUj4"};